// extracted by mini-css-extract-plugin
module.exports = {"ghost-indicator":"ghost-indicator--32L3h39x92","ghostIndicator":"ghost-indicator--32L3h39x92"};